const translation = {
  "site.title": "Itaobuy Spreadsheet Italia - Database Aggiornato 2026",
  "site.description": "Il database completo itaobuy spreadsheet per italiani. Scopri le migliori categorie prodotto, guide e recensioni aggiornate.",
  "nav.home": "Home",
  "nav.guida": "Guida",
  "nav.categorie": "Categorie",
  "hero.title": "Itaobuy Spreadsheet",
  "hero.subtitle": "Il database italiano più completo per lo shopping",
  "hero.cta_sheet": "itaobuy sheet",
  "hero.cta_buy": "buy it now",
  "categories.title": "Categorie Prodotto",
  "categories.subtitle": "Esplora tutte le categorie disponibili nel nostro database",
  "seo.title": "Itaobuy Spreadsheet: La Guida Completa per Italiani",
  "seo.description": "Scopri come utilizzare al meglio itaobuy spreadsheet, il database più aggiornato per trovare i migliori prodotti. Guide, recensioni e consigli per lo shopping online.",
  "seo.cta": "Leggi la guida completa →",
  "cta.title": "Pronto per iniziare?",
  "cta.subtitle": "Accedi subito al database completo e trova i prodotti che cerchi",
  "cta.button": "buy it now",
  "footer.brand": "itaobuy.",
  "footer.description": "Il punto di riferimento italiano per itaobuy spreadsheet. Database aggiornato, guide complete e le migliori categorie prodotto.",
  "footer.categories": "CATEGORIE",
  "footer.quick_links": "LINK UTILI",
  "footer.contact": "CONTATTO",
  "footer.copyright": "© 2026 itaobuyspread.baby. Tutti i diritti riservati.",
  "article.back_home": "← Torna alla home",
  "article.read_more": "Continua a leggere",
};

export default translation;